import React, { useState } from "react";
import Sidebar from "@/components/Sidebar";
import InstallBanner from "@/components/InstallBanner";

export default function DashboardLayout({ children }) {
  const [collapsed, setCollapsed] = useState(window.innerWidth < 768);

  return (
    <div className="min-h-screen bg-background">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />
      <InstallBanner />
      <div
        className={`transition-all duration-200 ${collapsed ? "ml-[60px]" : "ml-[220px]"}`}
        data-testid="dashboard-layout-content"
      >
        {children}
      </div>
    </div>
  );
}
